import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'

// Imports de imágenes
import img3 from '../Rehabilitacion/img3.jpg'
import img4 from '../Rehabilitacion/img4.jpg'
import img5 from '../Rehabilitacion/img5.jpg'
import img6 from '../Rehabilitacion/img6.jpg'
import img7 from '../Rehabilitacion/img7.jpg'
import img8 from '../Rehabilitacion/img8.jpg'
import img9 from '../Rehabilitacion/img9.jpg'
import img11 from '../Rehabilitacion/img11.jpg'
import img28 from '../Rehabilitacion/img28.jpg'

export class Rehabilitation3 extends Component {
    render() {
        const rehabItems = [
            { img: img3 }, { img: img4 }, { img: img5 },
            { img: img6 }, { img: img7 }, { img: img8 },
            { img: img9 }, { img: img11 }, { img: img28 }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Rehabilitation</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/Rehabilitation">{1}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>

                    {/* Sistema de 2 columnas para maximizar el detalle de los equipos */}
                    <Row className="justify-content-center g-4">
                        {rehabItems.map((item, idx) => (
                            <Col key={idx} xs={12} lg={6}>
                                <Card className="shadow-sm border-0 h-100">
                                    <Card.Body className="p-3 d-flex align-items-center justify-content-center">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                width: '100%', 
                                                height: 'auto', 
                                                objectFit: 'contain' 
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/Rehabilitation">{1}</Pagination.Item>
                        <Pagination.Item href="/en/Rehabilitation2">{2}</Pagination.Item>
                        <Pagination.Item active>{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}